/* tslint:disable */
/* eslint-disable */
/**
 * Toki Public APIs
 * API Gateway for all Toki Public APIs
 *
 * The version of the OpenAPI document: 4.8.7
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CustomerBasicFromJSON, CustomerBasicToJSON, } from './CustomerBasic';
/**
 * @export
 */
export const InvoiceBasicStatusEnum = {
    DontProccess: 'Dont Proccess',
    Draft: 'Draft',
    Paid: 'Paid',
    Ready: 'Ready',
    Generated: 'Generated',
    PartPaid: 'Part-paid',
    Unpaid: 'Unpaid',
    Overpaid: 'Overpaid',
    Overdue: 'Overdue',
    Cancelled: 'Cancelled',
    Invalidated: 'Invalidated',
    Sent: 'Sent'
};
/**
 * Check if a given object implements the InvoiceBasic interface.
 */
export function instanceOfInvoiceBasic(value) {
    if (!('invoiceId' in value) || value['invoiceId'] === undefined)
        return false;
    if (!('parentId' in value) || value['parentId'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('customer' in value) || value['customer'] === undefined)
        return false;
    if (!('invoiceNumber' in value) || value['invoiceNumber'] === undefined)
        return false;
    if (!('invoiceDate' in value) || value['invoiceDate'] === undefined)
        return false;
    if (!('paymentDeadline' in value) || value['paymentDeadline'] === undefined)
        return false;
    if (!('billingMonth' in value) || value['billingMonth'] === undefined)
        return false;
    if (!('totalInvoiceCost' in value) || value['totalInvoiceCost'] === undefined)
        return false;
    if (!('meteringPointsCount' in value) || value['meteringPointsCount'] === undefined)
        return false;
    if (!('currency' in value) || value['currency'] === undefined)
        return false;
    if (!('pdfUrl' in value) || value['pdfUrl'] === undefined)
        return false;
    if (!('hourlyInquiryUrl' in value) || value['hourlyInquiryUrl'] === undefined)
        return false;
    if (!('balance' in value) || value['balance'] === undefined)
        return false;
    return true;
}
export function InvoiceBasicFromJSON(json) {
    return InvoiceBasicFromJSONTyped(json, false);
}
export function InvoiceBasicFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'invoiceId': json['invoice_id'],
        'parentId': json['parent_id'],
        'status': json['status'],
        'customer': CustomerBasicFromJSON(json['customer']),
        'invoiceNumber': json['invoice_number'],
        'invoiceDate': (new Date(json['invoice_date'])),
        'paymentDeadline': (new Date(json['payment_deadline'])),
        'billingMonth': (new Date(json['billing_month'])),
        'totalInvoiceCost': json['total_invoice_cost'],
        'meteringPointsCount': json['metering_points_count'],
        'currency': json['currency'],
        'pdfUrl': json['pdf_url'],
        'hourlyInquiryUrl': json['hourly_inquiry_url'],
        'balance': json['balance'],
    };
}
export function InvoiceBasicToJSON(json) {
    return InvoiceBasicToJSONTyped(json, false);
}
export function InvoiceBasicToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'invoice_id': value['invoiceId'],
        'parent_id': value['parentId'],
        'status': value['status'],
        'customer': CustomerBasicToJSON(value['customer']),
        'invoice_number': value['invoiceNumber'],
        'invoice_date': ((value['invoiceDate']).toISOString().substring(0, 10)),
        'payment_deadline': ((value['paymentDeadline']).toISOString().substring(0, 10)),
        'billing_month': ((value['billingMonth']).toISOString().substring(0, 10)),
        'total_invoice_cost': value['totalInvoiceCost'],
        'metering_points_count': value['meteringPointsCount'],
        'currency': value['currency'],
        'pdf_url': value['pdfUrl'],
        'hourly_inquiry_url': value['hourlyInquiryUrl'],
        'balance': value['balance'],
    };
}
